import { c as _c } from "react/compiler-runtime";
import { BackupPolicyType, ResourceType, VaultStorageTier } from '@repo/api-gw-sdk';
import { useCallback, useMemo } from 'react';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { useSupportedResourceTypes } from '@/data/inventory/useSupportedResourceTypes';
export type GetBackupPolicyAvailableTypes = (policyType: BackupPolicyType, vaultStorageTier: VaultStorageTier) => ResourceType[];
export function useBackupPolicyAvailableTypes() {
  const $ = _c(60);
  const {
    GcpVmHighFrequencyBackupEnabled,
    RdsHighFrequencyBackupEnabled,
    SapHanaPitrSupport,
    AzureSqlVirtualMachineSupport,
    EnableBigQueryNativePolicy,
    AwsKeyspacesSupport,
    MongoAtlasSupport,
    AzureFilesSupport,
    AwsRdsNativeBackupSupport,
    AwsEksClusterBackupSupport,
    GoogleWorkspaceSupport,
    Microsoft365Support,
    EntraIdSupport
  } = useFeatureFlags();
  const allTypes = useSupportedResourceTypes();
  let t0;
  if ($[0] !== GcpVmHighFrequencyBackupEnabled) {
    t0 = GcpVmHighFrequencyBackupEnabled ? [ResourceType.GcpComputeEngineInstance] : [];
    $[0] = GcpVmHighFrequencyBackupEnabled;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== RdsHighFrequencyBackupEnabled) {
    t1 = RdsHighFrequencyBackupEnabled ? [ResourceType.AwsRds] : [];
    $[2] = RdsHighFrequencyBackupEnabled;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== AwsKeyspacesSupport) {
    t2 = AwsKeyspacesSupport ? [ResourceType.AwsKeyspacesTable] : [];
    $[4] = AwsKeyspacesSupport;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== MongoAtlasSupport) {
    t3 = MongoAtlasSupport ? [ResourceType.AtlasMongodbCluster] : [];
    $[6] = MongoAtlasSupport;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = [ResourceType.AwsEc2, ...t0, ...t1, ResourceType.AwsDynamoDb, ...t2, ResourceType.AwsS3, ResourceType.GcpCloudStorageBucket, ...t3];
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const HighFrequencySupportedResourceTypes = t4;
  let t5;
  if ($[13] !== AzureSqlVirtualMachineSupport) {
    t5 = AzureSqlVirtualMachineSupport ? [ResourceType.AzureSqlVirtualMachine] : [];
    $[13] = AzureSqlVirtualMachineSupport;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== SapHanaPitrSupport) {
    t6 = SapHanaPitrSupport ? [ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm] : [];
    $[15] = SapHanaPitrSupport;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = [...t5, ...t6];
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const pitrPolicySupportedResourceTypes = t7;
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [ResourceType.AwsRds];
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const nativePitrPolicySupportedResourceTypes = t8;
  let t9;
  if ($[21] !== EnableBigQueryNativePolicy) {
    t9 = [...(EnableBigQueryNativePolicy ? [ResourceType.GcpBigQuery] : [])];
    $[21] = EnableBigQueryNativePolicy;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const bigQueryNativePitrSupportedResourceTypes = t9;
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [ResourceType.AzureSqlDatabase];
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const azureSqlDatabaseNativePitrSupportedResourceTypes = t10;
  let t11;
  if ($[24] !== AwsRdsNativeBackupSupport) {
    t11 = AwsRdsNativeBackupSupport ? [ResourceType.AwsRds] : [];
    $[24] = AwsRdsNativeBackupSupport;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== AwsEksClusterBackupSupport) {
    t12 = AwsEksClusterBackupSupport ? [ResourceType.AwsEksCluster] : [];
    $[26] = AwsEksClusterBackupSupport;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t11 || $[29] !== t12) {
    t13 = [ResourceType.AwsFsx, ResourceType.AwsEfs, ResourceType.AwsDocumentdb, ResourceType.AwsNeptune, ...t11, ...t12];
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const awsNativeStandardPolicySupportedResourceTypes = t13;
  let t14;
  if ($[31] !== AzureFilesSupport) {
    t14 = [...(AzureFilesSupport ? [ResourceType.AzureFileShare] : [])];
    $[31] = AzureFilesSupport;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  const azureFilesPolicySupportedResourceTypes = t14;
  let t15;
  if ($[33] !== GoogleWorkspaceSupport) {
    t15 = [...(GoogleWorkspaceSupport ? [ResourceType.GoogleWorkspaceResource] : [])];
    $[33] = GoogleWorkspaceSupport;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  const googleWorkspacePolicySupportedResourceTypes = t15;
  let t16;
  if ($[35] !== Microsoft365Support) {
    t16 = [...(Microsoft365Support ? [ResourceType.Microsoft365Resource] : [])];
    $[35] = Microsoft365Support;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const microsoft365PolicySupportedResourceTypes = t16;
  let t17;
  if ($[37] !== EntraIdSupport) {
    t17 = [...(EntraIdSupport ? [ResourceType.AzureEntraIdResource] : [])];
    $[37] = EntraIdSupport;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  const entraIdPolicySupportedResourceTypes = t17;
  let t18;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = [ResourceType.AwsRds];
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  const dualSupportedResourceTypes = t18;
  let t19;
  if ($[40] !== allTypes || $[41] !== awsNativeStandardPolicySupportedResourceTypes || $[42] !== azureFilesPolicySupportedResourceTypes) {
    let t20;
    if ($[44] !== awsNativeStandardPolicySupportedResourceTypes || $[45] !== azureFilesPolicySupportedResourceTypes) {
      t20 = type => (!awsNativeStandardPolicySupportedResourceTypes.includes(type) || dualSupportedResourceTypes.includes(type)) && !azureFilesPolicySupportedResourceTypes.includes(type) && type !== ResourceType.GoogleWorkspaceResource && type !== ResourceType.Microsoft365Resource && type !== ResourceType.AzureEntraIdResource;
      $[44] = awsNativeStandardPolicySupportedResourceTypes;
      $[45] = azureFilesPolicySupportedResourceTypes;
      $[46] = t20;
    } else {
      t20 = $[46];
    }
    t19 = [...allTypes.filter(t20)];
    $[40] = allTypes;
    $[41] = awsNativeStandardPolicySupportedResourceTypes;
    $[42] = azureFilesPolicySupportedResourceTypes;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  const standardPolicySupportedResourceTypes = t19;
  let t20;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = [];
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== HighFrequencySupportedResourceTypes || $[49] !== awsNativeStandardPolicySupportedResourceTypes || $[50] !== azureFilesPolicySupportedResourceTypes || $[51] !== bigQueryNativePitrSupportedResourceTypes || $[52] !== entraIdPolicySupportedResourceTypes || $[53] !== googleWorkspacePolicySupportedResourceTypes || $[54] !== microsoft365PolicySupportedResourceTypes || $[55] !== pitrPolicySupportedResourceTypes || $[56] !== standardPolicySupportedResourceTypes) {
    t21 = {
      [BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY]: HighFrequencySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_PITR]: pitrPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_PITR]: nativePitrPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_STANDARD]: standardPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_STANDARD]: awsNativeStandardPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_BIGQUERY_NATIVE_PITR]: bigQueryNativePitrSupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_SQL_DATABASE_NATIVE_PITR]: azureSqlDatabaseNativePitrSupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_FILES]: azureFilesPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_GOOGLE_WORKSPACE]: googleWorkspacePolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_MICROSOFT_365]: microsoft365PolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_ENTRA_ID]: entraIdPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_UNSPECIFIED]: t20
    };
    $[48] = HighFrequencySupportedResourceTypes;
    $[49] = awsNativeStandardPolicySupportedResourceTypes;
    $[50] = azureFilesPolicySupportedResourceTypes;
    $[51] = bigQueryNativePitrSupportedResourceTypes;
    $[52] = entraIdPolicySupportedResourceTypes;
    $[53] = googleWorkspacePolicySupportedResourceTypes;
    $[54] = microsoft365PolicySupportedResourceTypes;
    $[55] = pitrPolicySupportedResourceTypes;
    $[56] = standardPolicySupportedResourceTypes;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  const supportedResourceTypes = t21;
  const policySupportedResourceTypes = supportedResourceTypes;
  let t22;
  if ($[58] !== policySupportedResourceTypes) {
    t22 = (policyType, vaultStorageTier) => {
      const availableTypes = policySupportedResourceTypes[policyType];
      return vaultStorageTier === VaultStorageTier.VAULT_STORAGE_TIER_COLD ? availableTypes.filter(_temp) : availableTypes;
    };
    $[58] = policySupportedResourceTypes;
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  return t22;
}
function _temp(resourceType) {
  return resourceType === ResourceType.AwsS3;
}